<template>
  <div class="about history2010">
    <h2 class="about-title">現在へ<span class="about-title__year">2011-</span></h2>
    <div class="content2">
      <div class="img-content__bg column-06">
        <p>選手権では、引き続き海外で活躍する日本人ライダーも多く、1996年からスタートし、2009年から日本ラウンドが開催され始めたFIMアジアロードレース選手権では、SS600クラスにおいて11年に藤原克昭選手、12年に清成龍一選手がアジアのチャンピオンに輝くなど、アジアでも日本人ライダーの強さを発揮している。また、FIM EWC 世界耐久ロードレース選手権では、2017-2018年シーズンにおいて、日本チームとして初めてF.C.C TSR Hondaが頂点に立ち、耐久の世界でも日本のチーム力を見せつけた。さらに国別対抗戦においてもトライアルでは日本代表チームが2016年と2019年に世界2位、エンデューロでは代表チームの一人、釘村 忠選手が2019年に日本人初となるゴールドメダルを獲得している。</p>
        <figure><img src="/img/about-2010_03.jpg" alt=""><img src="/img/about-2010_03_02.jpg" alt=""></figure>
      </div>
    </div>
    <div class="content1 section">
      <h3>MFJ東北復興応援ツーリング</h3>
      <div class="img-content__wrap">
        <div class="img-content__text">
          <p>MFJ創立50周年を迎えた2011年。国内では、2011年に発生した東日本大震災の復興支援チャリティイベントを各全日本選手権などで実施。またMFJ東北復興応援ツーリングを2015～2019年まで開催し、モータースポーツファンのみならず、多くのライダーが参加した。</p>
        </div>
        <Carousel :slides="slides"></Carousel>
      </div>
    </div>
    
    
    <div class="content3 section column">
      <div class="">
        <p>全日本選手権では最多勝利記録が更新されるなど、新たな歴史が刻まれた。さらに時代の変化にあわせ、SNSを活用するとともに、全日本のロードレースとモトクロスでは他競技に先行してレースやライダーのインタビューなどをライブで配信するなど、ファンとの新しいコミュニケーションの場を形成した。さらに国内ではMFJ承認競技として、ジムカーナ団体JAGEと連携しモトジムカーナグレートシリーズをツインリンクもてぎと岡山国際サーキットで初開催している。</p>
      </div>
      <figure><img src="/img/about-2010_04.jpg" alt=""></figure>
    </div>
    
    <div class="content4 section column">
      <figure><img src="/img/about-2010_05.jpg" alt=""></figure>
      <div>
        <h3>MFJモーターサイクルスポーツ殿堂</h3>
        <p>2018年には日本のモーターサイクルスポーツの歴史を後世に伝え、輝かしい実績のあった選手を顕彰するMFJモーターサイクルスポーツ殿堂を設立。これまでに高橋国光、伊藤光夫、本田宗一郎、吉村秀雄を顕彰した。</p>  
      </div>
    </div>
    
    <div class="content5 section column">
      <div>
        <h3>感動を与える<br>モーターサイクルスポーツを</h3>
        <p>そして2021年、MFJは創立60周年を迎えた。コロナ渦という歴史的な苦難に立ち向かいながら、「感動を与えるモーターサイクルスポーツを」を合言葉に、ファンの視点に立ち、ライダー・チーム・主催者・MFJが一体となってモーターサイクルスポーツの社会的認知を向上し、文化として継承してゆくことを目指していく。</p>
      </div>
      <figure><img src="/img/about-2010_06.jpg" alt=""></figure>
    </div>
    
  </div>
</template>

<script>
import Carousel from '@/components/Carousel';
export default {
  name: "tab2010",
  components: {
    Carousel,
  },
  data: () => {
      return {
        slides: [
            {url: '/img/about-2010_01.jpg', alt: 'img1'},
            {url: '/img/about-2010_02.jpg', alt: 'img2'}
        ],
      }
  },
};
</script>

<style lang="scss">
.history2010 {
  figure {
    margin: 0;
  }
  figcaption {
    font-size: 12px;
    margin-top: 10px;
  }
  .column {
    display: flex;
    justify-content: flex-start;
    > * {
      width: 48%;
    }
    > *:first-child {
      margin-right: 2%;
    }
    @media(max-width: 1200px) {
      display: block;
      > * {
        width: 100%;
      }
      > *:first-child {
        margin-right: 0;
        margin-bottom: 20px;
      }
    }
  }
  .content1 {
    > p {
      width: auto;
    }
    > figure {
      max-width: 240px;
      flex: 0 0 auto;
      width: 100%;
      padding: 15px;
      border: 1px solid #ccc;
    }
  }
  .content2 {
    background: url(/img/about-2010back.jpg) center center / cover no-repeat;
    padding: 0;
  }
  .content3{
    h3 {
      margin-top: 40px;
      margin-bottom: 10px;
    }
    &__image{
      margin-left: 20px;
      margin-right: 0;
      padding: 20px;
      border: solid 1px #dadada;
      img{
        width: 240px;
      }
      figcaption{
        font-size: 12px;
      }
    }
    .column {
      align-items: flex-start;
      > * {
        width: auto;
      }
      p {
        margin:0 0 10px;
      }
      figure {
        max-width: 240px;
        flex: 1 0 auto;
        width: 100%;
        border: 1px solid #ccc;
        padding: 15px;
      }
    }
  }
  .content4{
    img{
      margin-right: 30px;
    }
  }
}
.column-06{
  @media(min-width:768px){
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    figure{
      width: 300px;
    }
    P{
      width: calc(100% - 320px);;
    }
  }
}
</style>